import { SortParamsOfType } from '@epicuro-next/models/sorting';

export enum SortField {
  Account = 'account',
  None = 'none',
  StyleNumber = 'styleNumber',
  OrderNumber = 'orderNumber',
  RequestFor = 'requestedFor',
  EstimatedTimeOfArrival = 'estimatedTimeOfArrival',
  Quantity = 'quantity',
  InvoiceNumber = 'invoiceNumber',
  InvoiceDate = 'invoiceDate',
  Price = 'price',
  Value = 'value',
  MaterialNumber = 'materialNumber',
  ClientReferenceNumber = 'clientReferenceNumber',
  OrderReferenceNumber = 'orderReferenceNumber',
  PlacedDate = 'placedDate',
  RequestedDate = 'requestedDate',
}

export enum DetailPageSortField {
  Style = 'styler',
  Gender = 'gender',
  RequestedDate = 'requestedDate',
  ConfirmedDate = 'confirmedDate',
  RequestedQuantity = 'requestedQuantity',
  ConfirmedQuantity = 'confirmedQuantity',
  UnconfirmedQuantity = 'unconfirmedQuantity',
  DeliveredQuantity = 'deliveredQuantity',
  UnitPriceRrp = 'unitPriceRrp',
  UnitPriceGross = 'unitPriceGross',
  UnitPriceNet = 'unitPriceNet',
  Discount = 'discount',
  PriceNetTotal = 'priceNet',
  OrderStatus = 'orderStatus',
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export interface SortRule {
  field: SortField;
  direction: SortDirection;
}

export type OrderDetailSortParams = SortParamsOfType<DetailPageSortField>;
